import requests from "@/request/index";
// 登录
export const login1 = (data: any) => requests({ url: "api/cloud/base/login", method: "POST", data })